const KEY = "pb_share_ref";
const DAYS = 30;

export const captureRef = (ref, productId) => {
  if (!ref || !/^[a-f0-9]{24}$/i.test(ref)) return;
  try { localStorage.setItem(KEY, JSON.stringify({ ref, productId, at: Date.now() })); } catch { /* ignore */ }
};

export const getRef = (selfId) => {
  try {
    const d = JSON.parse(localStorage.getItem(KEY) || "null");
    if (!d || Date.now() - d.at > DAYS * 864e5) { localStorage.removeItem(KEY); return null; }
    return d.ref === selfId ? null : d.ref;
  } catch { return null; }
};

export const clearRef = () => { try { localStorage.removeItem(KEY); } catch { /* ignore */ } };

export const shareProductUrl = (productId, userId) =>
  `${process.env.REACT_APP_BACKEND_URL}/api/share/products/${productId}${userId ? `?ref=${userId}` : ""}`;
